export default __webpack_public_path__ + "static/media/swiss-dish-washer-multi.627117df.jpg";